import { BaseRenderable } from "./base_renderable"
import { Coordinate, Entity, WeaponCharacteristics } from "game-common/models"

export class Bullet extends BaseRenderable {
    private launchOffset?: Coordinate

    constructor(color: any = 0xff0000, alpha = 1.0,
        private readonly bowOffset?: (entity: Entity) => Coordinate | undefined) {
        super()

        super.beginFill(0xff0000, alpha)
        super.lineStyle(2, 0xff0000, alpha)
        super.drawRoundedRect(5, 0, 9, 1, 1)
        super.endFill()

        super.beginFill(0xffffff, 0.35)
        super.lineStyle(2, 0xffffff, 0.35)
        super.drawRoundedRect(2, 0, 4, 1, 1)
        super.endFill()

        super.beginFill(0xffffff, 0.1)
        super.lineStyle(2, 0xffffff, 0.1)
        super.drawRoundedRect(0, 0, 3, 1, 1)
        super.endFill()
    }

    updateRenderedLocationFrom(entity: Entity) {
        if (!this.launchOffset && entity.spriteId === WeaponCharacteristics.bow.bulletSpriteId) {
            const grip = this.bowOffset?.(entity)
            if (grip) {
                // Project aimed arrows from the bow through the cursor below.
                const muzzle = entity.crossFloorProjectile ? 0 : (WeaponCharacteristics.bow.muzzleFireOffset ?? 0) + 1
                this.launchOffset = { x: grip.x - Math.cos(entity.movement.angle) * muzzle,
                    y: grip.y - Math.sin(entity.movement.angle) * muzzle }
            }
        }
        if (entity.projectileTarget && entity.origin) {
            const dx = entity.projectileTarget.x - entity.origin.x
            const dy = entity.projectileTarget.y - entity.origin.y
            const lengthSquared = dx * dx + dy * dy
            // Continue the same projection beyond the cursor. Clamping at 1 switches
            // back to the simulation's heading and puts a visible kink in the flight.
            const progress = lengthSquared > 0
                ? Math.max(0, ((entity.location.x - entity.origin.x) * dx +
                    (entity.location.y - entity.origin.y) * dy) / lengthSquared) : 1
            const offset = this.launchOffset ?? { x: 0, y: 0 }
            this.x = entity.location.x + offset.x * (1 - progress)
            this.y = entity.location.y + offset.y * (1 - progress)
            this.rotation = Math.atan2(dy - offset.y, dx - offset.x)
            this.addSidecar(entity)
            return
        }
        if (entity.crossFloorProjectile) this.rotation = entity.movement.angle
        if (!this.launchOffset) return super.updateRenderedLocationFrom(entity)
        this.x = entity.location.x + this.launchOffset.x
        this.y = entity.location.y + this.launchOffset.y
        this.addSidecar(entity)
    }
}
